<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.header(slot='header')
        span.dateHeader {{ $t('auditory.filters.input_date.value') }}
        ods-date-picker(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions2',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          :format='$t("date_format_long_datepicker")',
          :canSelectSeconds='true',
          :clearable='false',
          clearIcon='',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true',
          align='right')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom', v-if="!isShowRefresh")
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")
      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            //- b2b-select
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')

              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop === 'idProject'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')

                  ods-select(v-else-if='selected.prop === "idReceiver"',
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterParties',
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
                  ods-select(v-else-if='selected.prop === "idSender"',
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterParties',
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'batch'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                        v-for='option in selected.options',
                        :key='option.id',
                        :label='$t("msg_generics.question." + option.type)',
                        :value='option.id')
                  ods-select(v-else-if="selected.prop === 'hidden'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                        v-for='option in selected.options',
                        :key='option.id',
                        :label='$t("msg_generics.question." + option.type)',
                        :value='option.id')
                  ods-select(v-else
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='formatterLabel(option.code)',
                      :value='option.id')
              //- DOCUMENT NUMBER
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'documentNumber')")
                ods-form-item.others-input(prop='documentNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.trim='filterForm.documentNumber',
                    @input='getSecondValue')
              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string' && (selected.prop !== 'documentNumber')")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')

              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.number='filterForm.secondValueNumber',
                    @input='getSecondValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native="onSubmit('filterForm')")
          div
            ods-tooltip.ods-ml-4(:content='$t("buttons.btnClear")', placement='bottom', v-if="isShowRefresh")
              ods-button(
                  icon='ods-icon-refresh',
                  size='small',
                  circle,
                  @click="activeRefreshAudit")

    .b2b-filters__container(v-if='listSelectedFiltersAudits && listSelectedFiltersAudits.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersAudits',
          :key='index')
          b2b-filter-button-auditorias(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonAuditorias from './B2bFilterButtonAuditoriaDocumentos'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-auditorias',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonAuditorias
  },

  data () {
    const _this = this
    return {
      // DatePicker
      dateTimePickerValue: [],
      filterDatePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      // Forumlario
      filterForm: {
        firstValue: '',
        secondValue: '',
        secondValueNumber: '',
        documentNumber: '',
        secondValueSelect: ''
      },
      tid: null,
      selected: {},
      selectedFilters: [],
      options: {},
      isShowRefresh: false,

      // Reglas Validación
      rules: {
        documentNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { type: 'number', message: this.$t('msg_generics.number_required') }
        ],
        secondValueSelect: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'queryAudits',
      'listSelectedFiltersAudits',
      'optionsFilterEmitter',
      'optionsFilterReceiver',
      'optionsFilterAuditDocumentType',
      'optionsFilterAuditDocumentFormat',
      'optionsFilterState',
      'optionsFilterService',
      'optionsFilterCommunication',
      'optionsFilterModule',
      'optionsFilterInvoiceDraftBuyer',
      'canAdminUser',
      'canAdminIndra'
    ])
  },

  watch: {
    '$route' (to) {
      this.listSelectedFiltersAudits = this.listSelectedFiltersAudtis
    }
  },

  methods: {
    activeRefreshAudit () {
      this.isShowRefresh = false
      this.handleDeleteAllFilters()
    },
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getAudits',
      'queryAuditsState',
      'listSelectedFiltersAuditsState',
      'getOptionsFilterAuditDocumentType',
      'getOptionsFilterAuditDocumentFormat',
      'getOptionsFilterStateAudits',
      'getOptionsFilterCommunication',
      'getOptionsFilterModule',
      'getOptionsFilterPartyMEFenixBackend',
      'optionsFilterReceiverState',
      'getOptionsService',
      'optionsServicesEnabledState',
      'optionsFilterEmitterState'
    ]),

    formatterLabel (code) {
      const type = this.selected.prop
      let key
      if (code.includes(' ')) {
        code = code.replace(' ', '_')
      } else if (code.includes('-')) {
        code = code.replace('-', '_')
      }
      switch (type) {
        case 'idDocumentType':
          key = 'auditory_doc_type.'
          break
        case 'idCommunicationsProtocol':
          key = 'auditory_communication_protocol.'
          break
        case 'idStatus':
          key = 'auditory_status.'
          break
        case 'idDocumentFormatInput':
          key = 'auditory_doc_format.'
          break
        case 'idDocumentFormatOutput':
          key = 'auditory_doc_format.'
          break
        case 'idAuditDocumentModule':
          key = 'auditory_module.'
          break
      }
      return this.$t(key + code)
    },
    getFirstValue (data) {
      this.filterForm.documentNumber = ''
      this.filterForm.secondValue = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data

      const aux = []
      this.optionsFilterReceiverState(aux)
      this.optionsFilterEmitterState(aux)
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select' && this.selected.prop === 'idProject') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.name
      } else if ((this.selected.componente === 'select' && this.selected.prop === 'idSender') ||
        (this.selected.componente === 'select' && this.selected.prop === 'idReceiver')) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.tradeName
        this.selected.partyId = this.selected.labelText
      } else if ((this.selected.componente === 'select' && this.selected.prop === 'batch') ||
        (this.selected.componente === 'select' && this.selected.prop === 'hidden')) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.value
        this.selected.labelText = this.$t('msg_generics.question.' + option.type)
      } else if (this.selected.componente === 'select') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = this.formatterLabel(option.code)
      }

      if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      }

      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      console.log('data:', data)
    },
    onSubmit (formName) {
      console.log(formName)
      this.isShowRefresh = false
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: 'Añadiendo el filtro seleccionado a la búsqueda ...'
          })
          try {
            const column = this.selected.prop
            switch (column) {
              case 'idSender':
                this.queryAudits.idSender = this.selected.query
                break
              case 'idReceiver':
                this.queryAudits.idReceiver = this.selected.query
                break
              case 'filename':
                this.queryAudits.filename = this.selected.query.trim()
                break
              case 'documentNumber':
                this.queryAudits.documentNumber = this.selected.query.trim()
                break
              case 'idDocumentType':
                this.queryAudits.idDocumentType = this.selected.query
                break
              case 'idStatus':
                this.queryAudits.idStatus = this.selected.query
                break
              case 'batch':
                this.queryAudits.batch = this.selected.query
                break
              case 'idProject':
                this.queryAudits.idProject = this.selected.query
                break
              case 'idCommunicationsProtocol':
                this.queryAudits.idCommunicationsProtocol = this.selected.query
                break
              case 'idAuditDocumentModule':
                this.queryAudits.idAuditDocumentModule = this.selected.query
                break
              case 'idDocumentFormatInput':
                this.queryAudits.idDocumentFormatInput = this.selected.query
                break
              case 'idDocumentFormatOutput':
                this.queryAudits.idDocumentFormatOutput = this.selected.query
                break
              case 'batchName':
                this.queryAudits.batchName = this.selected.query
                break
              case 'childCountFrom':
                this.queryAudits.childCountFrom = this.selected.query
                break
              case 'childCountTo':
                this.queryAudits.childCountTo = this.selected.query
                break
              case 'hidden':
                this.queryAudits.hidden = this.selected.query
                break
              case 'processingTimeFrom':
                this.queryAudits.processingTimeFrom = this.selected.query
                break
              case 'processingTimeTo':
                this.queryAudits.processingTimeTo = this.selected.query
                break
              default:
                break
            }
            this.selectedFilters = this.listSelectedFiltersAudits
            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersAuditsState(this.selectedFilters)

            this.selected = {}
            this.$refs[formName].resetFields()
            this.queryAudits.page = 0

            if (this.comprobarSeleccion()) {
              await this.queryAuditsState(this.queryAudits)
              dataQuery.query = this.queryAudits
              await this.getAudits(dataQuery)

              this.initForm()
            }
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!')
        }
      })
    },
    async getPartiesResults (data) {
      let role = ''
      let isSeller = true
      if (this.filterForm.firstValue.prop === 'idReceiver') {
        role = 'BUYER'
        isSeller = false
      } else {
        role = 'SELLER'
      }
      const requestParty = {
        role: role,
        seller: isSeller,
        projectId: [this.queryAudits.idProject],
        appFrom: 'B2bFiltersAuditoriaDocumentos',
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
      this.selected.options = response
      this.auxListParties = response
    },

    async filterParties (data) {
      let role = ''
      if (this.filterForm.firstValue.prop === 'idReceiver') {
        role = 'BUYER'
      } else {
        role = 'SELLER'
      }
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        } else { // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.auxListParties = []
          if (role === 'BUYER') {
            this.optionsFilterReceiverState(this.auxListParties)
          } else {
            this.optionsFilterEmitterState(this.auxListParties)
          }
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getDateTimePickerValue () {
      console.log('getDateTimePickerValue: ', this.dateTimePickerValue)
      if (!this.dateTimePickerValue) {
        console.log('Adentro dateTimePickerValue: ', this.dateTimePickerValue)
        this.dateTimePickerValue = []
        this.dateTimePickerValue.push(this.queryAudits.dateTimeFrom)
        this.dateTimePickerValue.push(this.queryAudits.dateTimeTo)
      } else {
        this.queryAudits.dateTimeFrom = this.dateTimePickerValue[0]
        this.queryAudits.dateTimeTo = this.dateTimePickerValue[1]

        const dataQuery = {
          query: {}
        }
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.filter_date')
        })
        try {
          if (this.comprobarSeleccion()) {
            await this.queryAuditsState(this.queryAudits)
            dataQuery.query = this.queryAudits
            await this.getAudits(dataQuery)
          }
        } catch (error) {
          console.log('getDateTimePickerValue CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        if (this.comprobarSeleccion()) {
          await this.queryAuditsState(this.queryAudits)
          dataQuery.query = this.queryAudits
          await this.getAudits(dataQuery)
        }
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    comprobarSeleccion () {
      if ((this.queryAudits.dateTimeFrom === undefined || this.queryAudits.dateTimeFrom === '') &&
        (this.queryAudits.dateTimeTo === undefined || this.queryAudits.dateTimeTo === '') &&
        (this.queryAudits.idSender === undefined || this.queryAudits.idSender === '') &&
        (this.queryAudits.idReceiver === undefined || this.queryAudits.idReceiver === '') &&
        (this.queryAudits.filename === undefined || this.queryAudits.filename === '') &&
        (this.queryAudits.documentNumber === undefined || this.queryAudits.documentNumber === '') &&
        (this.queryAudits.idDocumentType === undefined || this.queryAudits.idDocumentType === '') &&
        (this.queryAudits.idStatus === undefined || this.queryAudits.idStatus === '') &&
        (this.queryAudits.batch === undefined || this.queryAudits.batch === '') &&
        (this.queryAudits.idProject === undefined || this.queryAudits.idProject === '') &&
        (this.queryAudits.idCommunicationsProtocol === undefined || this.queryAudits.idCommunicationsProtocol === '') &&
        (this.queryAudits.idAuditDocumentModule === undefined || this.queryAudits.idAuditDocumentModule === '') &&
        (this.queryAudits.idDocumentFormatInput === undefined || this.queryAudits.idDocumentFormatInput === '') &&
        (this.queryAudits.idDocumentFormatOutput === undefined || this.queryAudits.idDocumentFormatOutput === '') &&
        (this.queryAudits.batchName === undefined || this.queryAudits.batchName === '') &&
        (this.queryAudits.hidden === undefined || this.queryAudits.hidden === '') &&
        (this.queryAudits.childCountFrom === undefined || this.queryAudits.childCountFrom === '') &&
        (this.queryAudits.childCountTo === undefined || this.queryAudits.childCountTo === '') &&
        (this.queryAudits.processingTimeFrom === undefined || this.queryAudits.processingTimeFrom === '') &&
        (this.queryAudits.processingTimeTo === undefined || this.queryAudits.processingTimeTo === '')) {
        this.$notify({
          title: this.$t('msg_generics.filter_no_selected'),
          type: 'info',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
        return false
      } else {
        return true
      }
    },

    async handleDeleteAllFilters () {
      console.log('handleDeleteAllFilters: ', this.listSelectedFiltersAudits)
      console.log(this.selectedFilters)

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })

      try {
        this.clearSelectedFilters = this.listSelectedFiltersAudits.map(item => {
          item.labelText = ''
          item.query = ''
          item.selected = false
          return item
        })
        console.log('CLEAR FILTERS: ', this.clearSelectedFilters)

        await this.listSelectedFiltersAuditsState(this.clearSelectedFilters)
        if (this.dateTimePickerValue && this.dateTimePickerValue[0]) {
          this.queryAudits.dateTimeFrom = this.dateTimePickerValue[0]
        }
        if (this.dateTimePickerValue && this.dateTimePickerValue[1]) {
          this.queryAudits.dateTimeTo = this.dateTimePickerValue[1]
        }
        this.queryAudits.idSender = ''
        this.queryAudits.idReceiver = ''
        this.queryAudits.filename = ''
        this.queryAudits.documentNumber = ''
        this.queryAudits.idDocumentType = ''
        this.queryAudits.idStatus = ''
        this.queryAudits.batch = ''
        this.queryAudits.idProject = ''
        this.queryAudits.idCommunicationsProtocol = ''
        this.queryAudits.idAuditDocumentModule = ''
        this.queryAudits.idDocumentFormatInput = ''
        this.queryAudits.idDocumentFormatOutput = ''
        this.queryAudits.batchName = ''
        this.queryAudits.hidden = ''
        this.queryAudits.childCountFrom = ''
        this.queryAudits.childCountTo = ''
        this.queryAudits.processingTimeFrom = ''
        this.queryAudits.processingTimeTo = ''

        await this.queryAuditsState(this.queryAudits)
        if (this.comprobarSeleccion()) {
          dataQuery.query = this.queryAudits
          await this.getAudits(dataQuery)
          this.selectedFilters = []
          await this.listSelectedFiltersAuditsState(this.selectedFilters)

          // Reseteamos la prop selected de los filtros
          this.resetSelectedOptions(this.options)

          this.initForm()
        } else {
          this.selectedFilters = []
          await this.listSelectedFiltersAuditsState(this.selectedFilters)
          this.resetSelectedOptions(this.options)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      if (this.comprobarSeleccion()) {
        await this.listSelectedFiltersAuditsState(data.listAfterRemove)
        this.initForm()
      } else {
        await this.listSelectedFiltersAuditsState(data.listAfterRemove)
      }
    },

    initForm () {
      if (!this.options.num_documento.selected) {
        this.filterForm.firstValue = this.options.num_documento
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          if (error.data.message === undefined) {
            errorSms = this.$t('error.e400')
          } else {
            errorSms = error.data.message
          }
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    if (!this.canAdminIndra) {
      delete this.options.processingTimeFrom
      delete this.options.processingTimeTo
    }

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersAudits)

    const dataQueryService = { page: 0, size: 1000, sort: 'name,ASC' }
    // let dataQuery={query:{}}

    this.optionsService = await this.getOptionsService(dataQueryService)
    await this.optionsServicesEnabledState(this.optionsService)

    // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios
    if (this.optionsFilterService.length < 2) {
      delete this.options.servicio
      // es projectID en vez de .servicio?
      if (this.optionsFilterService.length === 1) {
        this.queryAudits.idProject = this.optionsFilterService[0].id
      }
    }
    this.initForm()
    /* if(this.canAdminUser){
      let myQueryAudits = {}
      myQueryAudits.dateTimeFrom = fn.initDateFromAudit(0)
      myQueryAudits.dateTimeTo = new Date()
      await this.queryAuditsState(myQueryAudits)
    } */
    if (this.queryAudits.dateTimeFrom) {
      this.dateTimePickerValue.push(this.queryAudits.dateTimeFrom)
      this.dateTimePickerValue.push(this.queryAudits.dateTimeTo)
    }
    try {
      if (this.comprobarSeleccion()) {
        await this.queryAuditsState(this.queryAudits)
      }
      // No es necesario porque ya se hace en el B2bTableMenu...
      // dataQuery.query = this.queryAudits
      // await this.getAudits(dataQuery)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }

    await Promise.all([ // eslint-disable-line
      this.getOptionsFilterStateAudits(),
      this.getOptionsFilterCommunication(),
      this.getOptionsFilterModule(),
      this.getOptionsFilterAuditDocumentType(),
      this.getOptionsFilterAuditDocumentFormat()
    ]).catch(reason => {
      throw reason
    })
  },

  updated () {
    if (this.queryAudits.reset) {
      this.handleDeleteAllFilters()
      this.queryAudits.reset = false
      this.isShowRefresh = true
    }
    this.options.emisor.options = this.optionsFilterEmitter
    this.options.receptor.options = this.optionsFilterReceiver
    this.options.tipoDocumento.options = this.optionsFilterAuditDocumentType
    this.options.formatoEntrada.options = this.optionsFilterAuditDocumentFormat
    this.options.formatoSalida.options = this.optionsFilterAuditDocumentFormat
    this.options.estado.options = this.optionsFilterState
    if (this.optionsFilterService && this.optionsFilterService.length > 1) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.comunicacion.options = this.optionsFilterCommunication
    this.options.modulo.options = this.optionsFilterModule
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
.b2b-filters{
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 .2rem .8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }

  .ods-button{
    display: inline;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
::v-deep .b2b-search-bar__header-right {
    margin-right: 2.5rem;
  }
</style>
